<template>
    <form @submit.prevent="checkFunctionCall">
      <p v-show="sucessUdyamVerificationMsg" class="py-3 text-center bg-green-100 text-green-700 rounded-md mb-3 tracking-wide"> {{ sucessUdyamVerificationMsg }}</p>
      <p class="text-center tracking-wide">Don't worry if you don't have a GSTIN, just verify<br>your Udyam to give the best credit limit possible</p>
      <div class="mt-4 overflow-hidden rounded-xl" style="max-height:250px">
        <img src="../assets/UdyamVerificationImg.png" alt="Udyam Verification" class="rounded-xl max-h-full object-contain mx-auto"/>
      </div>
      <p v-if="!showInputBox && !udyamManualFlag" class="text-center mt-4 tracking-wide">
        We will send a verification OTP to your registered mobile number ({{ maskedPhoneNumber }}).<br>If you wish to proceed, please click the Verify button.
      </p>
      <p v-else class="text-center mt-4 tracking-wide">
        Please enter your Udyam Registration Number<br>to proceed with the verification.
      </p>
      <div v-if="showInputBox" class="flex flex-col items-center mt-4">
    <input type="text"
      v-model="udyamNumber"
      placeholder="Enter Udyam Number"
      class="sm:w-full md:w-1/2 udyamInputBox rounded-md focus:outline-none focus:ring-1 focus:ring-primary"
      @input="validateUdyamNumber"
    />
    <!-- Error Message -->
    <p v-if="showError" class="text-red-500 mt-2 text-sm">
      {{ inValidUdyamNumberErrorMessage }}
    </p>
    <span class="text-gray-500 text-center mt-3 text-sm">
      Please enter Udyam Number in format:<br>UDYAM-XY-00-0000000
    </span>
  </div>
        <div class="flex flex-col items-center my-3">
          <button class="text-primary underline py-3 text-center"
            @click.prevent="toggleInputBox" v-if="!showInputBox"
          >
            Use Udyam Number
          </button>
          <span class="underline cursor-pointer text-center my-2 text-primary" v-if="showInputBox && !udyamManualFlag" @click.prevent="toggleInputBox">Verify with Registered Mobile Number</span>
          <span class="underline cursor-pointer text-center mb-2 text-yellow-500" @click.prevent="skipUdyamProcess">Skip Udyam Verification</span>
        </div>
      <div class="flex justify-center">
        <custom-button
            variant="primary"
            size="primary"
            class="font-semibold w-full md:w-72 md:h-11 mt-2 justify-self-center md:justify-self-start cursor-pointer"
            type="submit"
            :disabled="(showInputBox && udyamNumber?.length<19) || showError"
            :loading="isLoading"
            >Verify</custom-button>
      </div>
    </form>
    <transition name="fade">
      <modal @close-modal="resetErrorMessage" v-if="errorMessage">
        <div
          class="bg-white px-12 py-8 grid gap-4 justify-center justify-items-center w-96 rounded-md text-center"
        >
          <img src="../assets/mandate-failure.svg" alt="Error" width="119" height="115" />
          <p class>{{ errorMessage }}</p>
          <custom-button variant="primary" type="button" @click="resetErrorMessage">Ok</custom-button>
        </div>
      </modal>
    </transition>
</template>
<script>
import { mapGetters } from 'vuex';
import CustomButton from './CustomButton.vue';
import Modal from './Modal.vue';

export default {
  name: 'UdyamVerification',
  components: {
    CustomButton,
    Modal
  },
  data() {
    return {
      customerPhoneNumber: undefined,
      showInputBox: false,
      showError: false,
      udyamNumber: '',
      udyamPattern: /^UDYAM-[A-Z]{2}-\d{2}-\d{7}$/i,
      inValidUdyamNumberErrorMessage: '',
      isLoading: false,
      udyamManualFlag: false,
      sucessUdyamVerificationMsg: undefined,
    };
  },
  computed: {
    ...mapGetters(['applicationId', 'errorMessage']),
    maskedPhoneNumber() {
      return this.maskPhoneNumber(this.customerPhoneNumber);
    }
  },
  created() {
    this.$store.commit('SET_ERROR_MESSAGE', undefined);
  },
  methods: {
    init() {
      const phoneNumber = localStorage.getItem('phone');
      this.customerPhoneNumber = phoneNumber || undefined;
      this.udyamManualFlag = this.$route.params.udyamVerificationManualFlag;
      if (this.udyamManualFlag) this.showInputBox = true;
    },
    resetErrorMessage() {
      this.$store.commit('SET_ERROR_MESSAGE', undefined);
      this.$router.push({ name: 'Pre Approval Step 3' });
    },
    maskPhoneNumber(phoneNumber) {
      if (!phoneNumber || phoneNumber.length < 10) return phoneNumber;
      const lastPart = phoneNumber.substring(phoneNumber.length - 4);
      return `******${lastPart}`;
    },
    toggleInputBox() {
      this.showInputBox = !this.showInputBox;
    },
    validateUdyamNumber() {
      if (this.udyamNumber?.length >= 19 && !this.udyamPattern.test(this.udyamNumber)) {
        this.showError = true;
        this.inValidUdyamNumberErrorMessage = 'Invalid Udyam Number format.';
      } else {
        this.showError = false;
      }
    },
    checkFunctionCall() {
      if ((this.udyamNumber && !this.showError) && this.showInputBox) {
        this.verifyUdyamNumber();
      } else {
        this.goToUdyamOtpVerification();
      }
    },
    verifyUdyamNumber() {
      this.$trackEvent(this.$mixpanelEvent.UDYAM_NUMBER_SUBMIT);
      this.isLoading = true;
      const params = {
        applicationId: this.applicationId,
        udyamNumber: this.udyamNumber
      };
      this.$store
        .dispatch('submitUdyamDetails', params)
        .then(() => {
            this.isLoading = false;
            this.sucessUdyamVerificationMsg = "Udyam Number Verification Successful!";
            setTimeout(() => {
              this.sucessUdyamVerificationMsg = undefined;
              this.$router.push({ name: 'Pre Approval Step 3' });
            }, 5000);
        })
        .catch(() => {
          this.isLoading = false;
          this.udyamNumber = '';
        });
    },
    goToUdyamOtpVerification() {
      this.$trackEvent(this.$mixpanelEvent.UDYAM_OTP_TRIGGERED);
      this.isLoading = true;
      const params = {
        applicationId: this.applicationId,
      };
      this.$store
        .dispatch('generateOtp', params)
        .then((result) => {
          this.isLoading = false;
          const requestId = result.request_id;
          this.$router.push({ name: 'Udyam OTP Verification', params: { requestId } });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    skipUdyamProcess() {
      this.$trackEvent(this.$mixpanelEvent.UDYAM_SKIPPED);
      this.$router.push({ name: 'Pre Approval Step 3' });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style scoped>
</style>
